import React, { useCallback } from 'react'

import EditableItemFooter from './EditableItemFooter'
import OwnBookingFooter from './OwnBookingFooter'
import ReadOnlyItemFooter from './ReadOnlyItemFooter'

import TextButton from 'LuxKit/Button/TextButton'
import { useAppSelector } from 'hooks/reduxHooks'
import offerPageURL from 'lib/offer/offerPageURL'
import { getCurrentUserId } from 'selectors/accountSelectors'
import FooterWithCreateUpdateInfo from 'tripPlanner/components/TripModal/Common/FooterWithCreateUpdateInfo'
import useOffer from 'hooks/Offers/useOffer'
import useImmersiveModeHandlers from 'tripPlanner/hooks/useImmersiveModeHandlers'
import { CruiseItem, TourItem } from 'tripPlanner/types/tripItem'
import {
  getOfferId,
  getOrderId,
  isLeBooking,
  isLeBookmark,
} from 'tripPlanner/utils'
import { tripItemSelectionId } from 'tripPlanner/utils/itemSelection'

interface Props {
  item: CruiseItem | TourItem
}

export default function TourAndCruiseSummaryModalFooter({ item }: Props) {
  const offerId = getOfferId(item)
  const [offer] = useOffer<App.Offer | App.OfferSummary | App.Tours.TourV2Offer>(offerId)
  const userId = useAppSelector(getCurrentUserId)
  const { setImmersiveMode } = useImmersiveModeHandlers()

  const setImmersive = useCallback(
    () =>
      setImmersiveMode({
        tripId: item.tripId,
        sectionId: tripItemSelectionId(item.id),
      }),
    [item, setImmersiveMode],
  )

  const orderId = getOrderId(item)

  if (isLeBooking(item) && orderId) {
    if (item.createdBy === userId) {
      return <OwnBookingFooter item={item} orderId={orderId} />
    } else {
      return <ReadOnlyItemFooter item={item} />
    }
  } else if (isLeBookmark(item)) {
    if (!offer) {
      return null
    }
    return (
      <FooterWithCreateUpdateInfo item={item}>
        <TextButton
          kind="primary"
          to={offerPageURL(offer)}
          onClick={setImmersive}
        >
          View offer
        </TextButton>
      </FooterWithCreateUpdateInfo>
    )
  } else {
    return <EditableItemFooter item={item} />
  }
}
